export type PatternCategory =
  | 'name'
  | 'address'
  | 'contact'
  | 'security'
  | 'securityTraveler';

export type PatternMap = {
  [key: string]: RegExp;
};
